export default "__VITE_PUBLIC_ASSET__1208effd__"